import getVideoId from 'get-video-id';
import { parseDashboardVideo as parseVideo } from '../../../groove-ui-kit-v2/src/vue2/dashboard-setting-values';
export * from '../../../groove-ui-kit-v2/src/vue2/dashboard-setting-values';
export const parseDashboardVideo = value => parseVideo(value, getVideoId);
